import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { ShieldCheck, ArrowRight, Loader2 } from 'lucide-react';
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

const VerifyOtp = () => {
    const [otp, setOtp] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const { login } = useContext(AuthContext);

    // Email passed from Signup page
    const email = location.state?.email;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1'}/users/verify_otp`, {
                email,
                otp
            });

            // If successful, log the user in immediately
            login(response.data.user, response.data.token);
            navigate('/');
        } catch (err) {
            setError(err.response?.data?.error || "Verification failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (!email) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background text-white">
                <p>No email provided. Please sign up first.</p>
            </div>
        );
    }

    return (
        <div className="min-h-screen pt-20 flex items-center justify-center relative overflow-hidden">
            {/* Background */}
            <div className="absolute inset-0 bg-background">
                <div className="absolute top-0 left-0 w-[50%] h-[50%] bg-primary/20 rounded-full blur-[120px] animate-pulse"></div>
                <div className="absolute bottom-0 right-0 w-[50%] h-[50%] bg-secondary/10 rounded-full blur-[120px] animate-float"></div>
            </div>

            <div className="relative w-full max-w-md mx-4">
                <div className="bg-surface/50 backdrop-blur-xl border border-white/10 rounded-3xl p-8 shadow-2xl text-center">
                    <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                        <ShieldCheck className="w-8 h-8 text-green-500" />
                    </div>

                    <h2 className="text-3xl font-bold font-display text-white mb-2">Verify Email</h2>
                    <p className="text-slate-400 mb-8">
                        We sent a 4-digit code to <br />
                        <span className="text-white font-medium">{email}</span>
                    </p>

                    {error && (
                        <div className="bg-red-500/10 text-red-400 p-3 rounded-lg mb-6 text-sm">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <input
                                type="text"
                                maxLength="4"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
                                className="w-full bg-background/50 border border-white/10 rounded-xl py-4 text-center text-3xl tracking-[1em] text-white placeholder:text-slate-600 focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/50 transition-all font-mono"
                                placeholder="0000"
                                autoFocus
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={loading || otp.length !== 4}
                            className="w-full bg-primary text-white font-bold py-3.5 rounded-xl shadow-lg hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
                        >
                            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> :
                                <>
                                    Verify & Continue <ArrowRight className="w-5 h-5" />
                                </>
                            }
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default VerifyOtp;
